import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MobileStepper from "@material-ui/core/MobileStepper";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { IOffer } from "./ICart";
import { CartOffer } from "./CartOffer";

interface IParams {
    arrowStep: number;
    carouselItemCount: number;
    offerList: IOffer[];
    handleBack(): void;
    handleNext(): void;
    handleOfferClick(selectedOffer: IOffer): void;
}
export const CartOfferListDesktop = (props: IParams) => {
    const { arrowStep, carouselItemCount, handleBack, handleNext, handleOfferClick, offerList } = props;

    return (
        <Grid alignItems="center" container justify="center" spacing={8}>
            {offerList
                .slice(offerList.length < arrowStep ? offerList.length : arrowStep, arrowStep + carouselItemCount)
                .map((offer, index) => (
                    /* eslint-disable-next-line react/no-array-index-key */
                    <Grid item key={index} sm={5}>
                        <CartOffer handleOfferClick={handleOfferClick} offer={offer} />
                    </Grid>
                ))}
            {offerList.length > 1 && (
                <Grid item xs={3}>
                    <MobileStepper
                        activeStep={arrowStep}
                        backButton={
                            <Button color="primary" disabled={arrowStep === 0} size="small" onClick={handleBack}>
                                <KeyboardArrowLeft fontSize="large" />
                            </Button>
                        }
                        nextButton={
                            <Button
                                color="primary"
                                disabled={arrowStep + carouselItemCount >= offerList.length}
                                size="small"
                                onClick={handleNext}
                            >
                                <KeyboardArrowRight fontSize="large" />
                            </Button>
                        }
                        position="static"
                        steps={offerList.length}
                        variant="dots"
                    />
                </Grid>
            )}
        </Grid>
    );
};
